import styled from 'styled-components';
import { Row, Popover } from 'antd';
import InfoIconPlaceholder from 'Components/people/components/InfoIconPlaceholder';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { ToolTipOfTopPeople } from 'Types/BuyerGroupsPageTypes';
import classNames from 'classnames';
import { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsScroll, selectHighlight, selectActivetype, selectIsHighlighted,
} from 'Selector/CertificationSelector';
import { actions as certificationActions } from '../../../Slice/CertificationSlice';

type Props = {
  title?: string,
  children: ReactNode,
  loading?: boolean,
  toolTip?: ToolTipOfTopPeople
  rowClassName?: string,
} & typeof defaultProps;

const defaultProps = {
  title: 'Drawar',
  loading: false,
  toolTip: {},
  rowClassName: '',
};

const Wrapper = styled.div``;

const tooltip = function tooltip(toolTipProps: ToolTipOfTopPeople) {
  const { description, dataList } = toolTipProps;
  return (
    <div>
      {
        description?.length ? (
          <div className="label-popover">
            {description}
          </div>
        ) : null
      }
      {
        dataList?.length ? (
          <ul>
            {
              dataList.map((point) => (
                <li key={point}>
                  {point}
                </li>
              ))
            }
          </ul>
        ) : null
      }
    </div>
  );
};

const BuyerColumn = function BuyerColumn(props: Props) {
  const {
    title, loading, children, toolTip, rowClassName,
  } = props;

  const isScroll = useSelector(selectIsScroll);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isHighlighted && !isScroll && currentType === 'buyer_group') {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);

  useEffect(() => {
    if (currentType === 'buyer_group') {
      window.scrollTo(0, 350);
    }
  }, [currentType]);

  return (
    <Wrapper className={classNames(
      'white-wrapper-buyer',
      { highlightedComponent: isHighlight && currentType === 'buyer_group' },
    )}
    >
      {
        loading ? (
          <div className="text-center">
            <SkeletonCustom
              height="20px"
              width="160px"
            />
          </div>
        ) : (
          <div className="box-title">
            {title}
            {
              toolTip ? (
                <Popover
                  placement="bottomRight"
                  content={tooltip(toolTip)}
                  overlayClassName="hover-general-popover"
                  getPopupContainer={(e: HTMLElement) => e}
                  arrow={false}
                >
                  <span className="f-right">
                    <InfoIconPlaceholder />
                  </span>
                </Popover>
              ) : null
            }
          </div>
        )
      }
      <Row gutter={16} className={rowClassName}>
        {children}
      </Row>
    </Wrapper>
  );
};
BuyerColumn.defaultProps = defaultProps;
export default BuyerColumn;
